import { Text } from '@chakra-ui/react';

import SectionStartTemplate from '../../../templates/sectionStart';
import { SectionStatus } from '../../../sections/types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { useTranslation } from "react-i18next";

export interface IProps {
  personalInfoStatus: SectionStatus;
  historyStatus: SectionStatus;
  consentsStatus: SectionStatus;
}
type Props = IProps;

const FinancesSectionStart = (props: Props) => {
    const { t } = useTranslation('common');
  const { navigateBackward, navigateForward, navigateToStudentDashboard } = useCustomNavigate();

  const onPrevious = () => navigateBackward();
  const onNext = () => navigateForward();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      section1={props.personalInfoStatus}
      section2={props.historyStatus}
      section3={props.consentsStatus}
      section4={SectionStatus.todo}
      section="Section 4 - Your Financial Plan"
      minsToComplete={10}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
    >
      <Text fontSize={'lg'}>{t('common:inThisSectionYouWillProvideDetai')}</Text>
    </SectionStartTemplate>
  );
};

export default FinancesSectionStart;
